import { generateMedia, pxToRem } from 'styled-media-query'

import ScreenSizes from './screenSizes'

const breakpointsInRem = pxToRem({
  xs: ScreenSizes.xs,
  sm: ScreenSizes.sm,
  md: ScreenSizes.md,
  lg: ScreenSizes.lg,
  xl: ScreenSizes.xl,
  xxl: ScreenSizes.xxl
})

const customMedia = generateMedia(breakpointsInRem)

export default customMedia
